import { Box, Typography } from '@mui/material'

import Item from '@ecm/ui/component/menu/Item'
import Color from '@ecm/ui/element/Color'

import businessIcon from '/public/images/icon/business.svg'
import addressIcon from '/public/images/icon/location-pin.svg'
import mailboxIcon from '/public/images/icon/mailbox-left.svg'

const content = [
  {
    heading: 'Virtual Mailbox for individuals',
    href: '/virtual-mailbox',
    icon: mailboxIcon,
    subHeading: 'Access and manage your postal mail online',
  },
  {
    heading: 'Virtual Mailbox for business',
    href: '/virtual-mailbox-for-business',
    icon: businessIcon,
    subHeading: 'Online mail management for your business',
  },
  {
    heading: 'Virtual Business Address',
    href: '/virtual-business-address',
    icon: addressIcon,
    subHeading: 'Protect your privacy with a real US address',
  },
]

const Products = () => (
  <Box p={{ md: '0 0.5em 0 1.5em', xs: '2em 1em 1em' }} bgcolor={Color.white.normal}>
    <Typography variant="overline" mb="1.5em" color={Color.saint.lighter}>
      Products
    </Typography>
    {content.map(({ heading, href, icon, subHeading }) => (
      <Box key={heading} mb={{ md: '0.75em', xs: '1em' }} width={{ md: '388px' }}>
        <Item href={href} icon={icon} heading={heading} subHeading={subHeading} />
      </Box>
    ))}
  </Box>
)

export default Products
